import * as React from "react";
import {isEqual as _isEqual} from "lodash"
import { FormItemMode } from "../../../utils/AppConstants";

interface PrescriptionAdviceViewProps {
    data: any
    index: number
    allData: { item: any, mode: FormItemMode }[];
}

const PrescriptionAdviceView: React.SFC<PrescriptionAdviceViewProps> = (props) => {
    const {data} = props;
    const isDuplicate = props.allData.findIndex((obj: any) => _isEqual(obj.item.doctorAdvice, data.doctorAdvice)) !== props.index
    return (
        <div className={`list-view-template ${isDuplicate ? "is-duplicate" : ""}`}>
            {data.doctorAdvice.displayValue}
        </div>
    )
}

export default PrescriptionAdviceView;